import OliverText from "@builder/components/general/OliverText";
import "./onboardinput.scss";
import { formatTestId } from "@builder/utils/format";
interface OnboardInputProps {
  label: string;
  value?: string;
  onChange: (val: string) => void;
  placeholder: string;
  showErrors: boolean;
}

const OnboardInput = ({ label, value, onChange, placeholder, showErrors }: OnboardInputProps) => {
  const error = showErrors && !value;
  return (
    <div className="onboard-input-wrapper">
      <OliverText size="xs" color="base-grey" weight="light">{label}</OliverText>
      <input
        type="text"
        data-testid={formatTestId("onboard-input", label)}
        placeholder={placeholder}
        className={error ? "onboard-input-error" : ""}
        value={value || ""}
        onChange={e => onChange(e.target.value)}
      />
      {error && <span className="onboard-error-text"><img src="/error2.svg" alt="error" /> This input is required</span>}
    </div>
  );
};

export default OnboardInput;
